import React from 'react'
import './ArchivalBanner.scss'

const ArchivalBanner = () => {
  return (
    <aside className='iliad__archival-banner' role='note' aria-live='polite'>
      This project was designed and developed by Grand Rapids Tech. The
      original business is no longer operating. This archived demonstration
      exists solely for portfolio purposes.
    </aside>
  )
}

export default ArchivalBanner
